import React from 'react'
import {connect} from 'react-redux'
//import { Container, Row, Col} from 'reactstrap';
import { Container} from 'reactstrap';
import SalesRow from '../components/SalesRow'
//import {formatCurrency} from '../utils/Strings'

const mapStateToProps = state => {  
  return {    
    //reservations: state.report.reservations,
    sales: state.report.sales,
    ticketUrlPath: state.report.ticketUrlPath,
    filter: state.report.salesFilter,    
    infoText: state.report.salesInfo,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return { 
//      onCourseChoose: (ownProps, courseIdx) => {        
//        dispatch(setCourse(courseIdx))
//      },
//    onGetCourses: (ownProps) => {          
//      dispatch(fetchCourses(ownProps.agentLogin))
//    },    
  }
}

class SalesList extends React.Component{
  constructor (props) {
    super(props)
    this.state = {      
//      onCourseChoose: props.onCourseChoose,     
    };
//    this.handleCourseChoose = this.handleCourseChoose.bind(this);
  }
//  handleCourseChoose(idx){
//    //alert('Wybrano ' + idx)
//    this.state.onCourseChoose(this.state, idx)
//  }
  renderInfoText() {
    return (
      <p className="center"><br/>{this.props.infoText}</p>
    )
  }
  render() {
    if (this.props.infoText.length>0)
      return this.renderInfoText()
   
    if (this.props.sales.length>0){
      // var qtyNormalSum=0
      // var qtyReducedSum=0
      // var totalPriceSum=0.00
      // for(var i=0; i<this.props.reservations.length; i++){
      //   var r=this.props.reservations[i]
      //   if (!r.isCanceled){
      //     qtyNormalSum += parseInt(r.qtyNormal,10)
      //     qtyReducedSum += parseInt(r.qtyReduced, 10)
      //     totalPriceSum += parseFloat(r.totalPrice)
      //   }
      // }
      // var strQty=''
      // if (qtyNormalSum>0)
      //   strQty += qtyNormalSum + "N "
      // if (qtyReducedSum>0)
      //   strQty += qtyReducedSum + "U"
      
      return ( 
        <Container fluid={true} className="defList">
          <h3>Raport sprzedaży</h3>
          {/* <pre>
            AA
            {JSON.stringify(this.props.sales)}            
          </pre> */}
          {this.props.sales.map((sales, index) => (            
            <SalesRow 
              key={index} 
              index={index}
              data={sales}  
              ticketUrlPath={this.props.ticketUrlPath} 
              periodType={this.props.filter.period}            
            />
          ))}
          {/* <Row className="align-items-center sumRow">
            <Col md="10" xs="3">
            RAZEM:
            </Col>
            <Col md="1" xs="1">
            {strQty}
            </Col>
            <Col md="1" xs="2">
            {formatCurrency(totalPriceSum)}
            </Col>
          </Row> */}
        </Container>
      )
    }
    else
      return this.renderInfoText();
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SalesList)    


// WEBPACK FOOTER //
// ./src/containers/SalesList.js